export default "__VITE_ASSET__CG2OgRBd__"